<template>
   
  <a-card >
   <a-page-header
      title="测试任务"
      :subTitle="case_id ? `CaseID: ${case_id}` : `批次ID: ${batch_id}`"
      @back="() => GoPrev()"
    />
    <div v-if="batch_id" >
       <a-card :body-style="{ padding: 0, overflow: 'hidden' }">
          <a-typography>
            <a-typography-title :level="3">
              {{ currentBatch.batch_name }} 
              <a-tag v-if="currentBatch.status == 4" color="red">已终止</a-tag>
              <a-tag v-else-if="currentBatch.total_count == currentBatch.executed_count" color="green">已完成</a-tag>
              <a-tag v-else >正常</a-tag>
              <a-space>
                <a-button @click="handleStopBatch" danger v-if="currentBatch.total_count > currentBatch.executed_count && currentBatch.status != 4">终止执行</a-button>
                <a-popconfirm
                  title="确认重跑该批次吗？确认后会创建一个新的测试批次"
                  ok-text="确定"
                  cancel-text="还是不了"
                  @confirm="handleRerun(currentBatch)"
                >
                  <a-button   danger   >重跑</a-button>
                </a-popconfirm>
              </a-space>
            </a-typography-title>
            <a-row>
              <a-col :span="3">TaskStyle: </a-col>
              <a-col :span="18">{{ StyleFlowNames[currentBatch.style_id] }}</a-col>
            </a-row>
            <a-row>
              <a-col :span="3">RemoteURL: </a-col>
              <a-col :span="18">{{ currentBatch.remote_url }}</a-col>
            </a-row>
            <a-row>
              <a-col :span="3">总数: </a-col>
              <a-col :span="18">{{ currentBatch.total_count }}</a-col>
            </a-row>
            <a-row>
              <a-col :span="3">已执行数量: </a-col>
              <a-col :span="18">{{ currentBatch.executed_count }}</a-col>
            </a-row>
          </a-typography>
          
        </a-card>
    </div>
    <div v-if="case_id">
        <a-card :body-style="{ padding: 0, overflow: 'hidden' }">
          <a-flex justify="flex-start" style="margin: 10px;">
            <a-typography>
              <a-typography-title :level="3">
                {{ currentCase.case_name }}  
              </a-typography-title>
              <div>TaskStyle: {{ StyleFlowNames[currentCase.style_id] }}</div>
              <div>TaskID: 
                <a v-if="currentCase.task_id" :href="'/home/creation/works/review?task_id=' + currentCase.task_id " target="_blank">{{ currentCase.task_id }}</a>
                <span v-else>(自定义)</span>
              </div>
            </a-typography>
            
            <TestcaseRun style="margin-left: 10px;" @ok="CaseExecuted" :case="currentCase" :batchBy="{ ids: [case_id]}" />
          </a-flex>
        <a-image-preview-group >
          <a-flex justify="center" align="center" style="padding: 10px;">
            <div class="case-image-item">
              <video 
                v-if="currentCase.base_image_key && (currentCase.base_image_key.indexOf('.mp4') > 0 || currentCase.base_image_key.indexOf('.mov') > 0)"
                preload="none"
                poster="http://statica.xuantu.pro/static/upload/20260121_upload_3961633838326165.jpeg"
                :src="rawImage(currentCase.base_image_key)"
                controls
                style="max-width: 200px; max-height: 356px;"
              />
              <a-image v-else
              alt="avatar"
              :preview='{ src: rawImage(currentCase.base_image_key)}'
              :src="thumbnail(currentCase.base_image_key)"
              style="width: 200px;height: auto;"
            />
             <a-tag color="blue" >原图</a-tag>
            </div>
            <div>➕</div>
            <div v-if=" currentCase.mask_image_key" class="case-image-item" >
              <a-image
                alt="avatar"
                :preview='{ src: rawImage(currentCase.mask_image_key)}'
                :src="thumbnail(currentCase.mask_image_key)"
                style="width: 200px;height: auto;"
              />
              <a-tag color="black" >MASK</a-tag>
            </div>
             <div v-else >
              (no mask)
            </div>
             <div>➕</div>
             <div v-if=" currentCase.refer_image_key" class="case-image-item" >
              <a-image
                alt="avatar"
                :preview='{ src: rawImage(currentCase.refer_image_key)}'
                :src="thumbnail(currentCase.refer_image_key)"
                style="width: 200px;height: auto;"
              />
              <a-tag color="orange" >参考图</a-tag>
            </div>
             <div v-else >
              (no refer)
            </div>
            <div>➕</div>
            <div class="case-image-item">
              <div v-if="currentCase.prompt" style="padding: 4px; border-radius: 8px;; background-color: #f5f5f5;">
                {{ currentCase.prompt }}
              </div>
              <span v-else>
                (no prompt)
              </span>
            </div>
            <div>🟰</div>
            <div v-if=" currentCase.work_image_key" class="case-image-item" >
               <video 
                v-if="currentCase.work_image_key.indexOf('.mp4') > 0 || currentCase.work_image_key.indexOf('.mov') > 0"
                preload="none"
                poster="http://statica.xuantu.pro/static/upload/20260121_upload_3961633838326165.jpeg"
                :src="rawImage(currentCase.work_image_key)"
                controls
                style="max-width: 200px; max-height: 356px;"
              />
              <a-image v-else
                alt="avatar"
                :preview='{ src: rawImage(currentCase.work_image_key)}'
                :src="thumbnail(currentCase.work_image_key)"
                style="width: 200px;height: auto;"
              />
              <a-tag color="green" >结果图</a-tag>
            </div>
             <div v-else >
              (no work)
            </div>
          </a-flex>
          </a-image-preview-group>
          <div style="padding: 10px;">
            <span>标签: </span>
            <a-tag v-for="label of currentCase.labels" :key="label.id" >{{ label.name }}</a-tag>
          </div>
          <a-collapse v-model:activeKey="showMoreCaseParams" style="margin:10px;">
            <a-collapse-panel key="1" header="更多生成参数">
              <div style="background: #EFEFEF;padding:10px;">
                <div v-for="(value, key) of currentCase" :key="key">
                  <a-row >
                    <a-col :span="3" >{{ key }}:</a-col>
                    <a-col :span="21" style="margin-top:4px;" >
                      <div v-if="key == 'extra_params' || key == 'works'">
                        <pre>{{ value }}</pre>
                      </div>
                      <div v-else-if="typeof value == 'number' ">
                        <a-tag>{{ value }}</a-tag>
                      </div>
                      <div v-else-if="value === '' ">
                      
                        <a-tag>&lt;empty&gt;</a-tag>
                      </div>
                      <div v-else>{{ value }}</div>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </a-card>
    </div>
    <a-alert :message="noticeMessage" type="info" show-icon style="margin: 10px;text-align: left;"  />
    <a-button style="margin: 10px;" type="primary" @click="reload()">刷新</a-button>
    <a-table 
      class="ant-table-striped"
      show-quick-jumper
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      :scroll="{ x: 1500 }"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >

      <template #task_id="{ record }">
       <a :href="'/home/creation/works?task_id=' + record.task_id" target="_blank">{{ record.task_id }}</a>
      </template>
      <template #status="{ record }">
        <a-tag v-if="record.status == 1" color="green">有效</a-tag>
        <a-tag v-else color="red">作废</a-tag>
      </template>
      <template #labels="{ record }">
        <a-tag v-if="record.style_id !== ''" color="blue" >{{  StyleNames[record.style_id]  }}</a-tag>
        <a-tag v-for="label of record.labels" :key="label.id" >{{ label.name }}</a-tag>
      </template>
      <template #prompt="{ record }">
        <div style="padding: 4px; border-radius: 8px;; background-color: #f5f5f5; max-height: 200px; max-width: 100px; overflow: auto;">
          {{ record.prompt }}
        </div>
      </template>
      <template #image_gallary="{ record }">
        <div class="img-thumbnail" style="width: 840px; display: flex;" >
            <a-image-preview-group >
              <div v-if="record.base_image_key" class="thumbnail-item">
                <video 
                  v-if="record.base_image_key.indexOf('.mp4') > 0 || record.base_image_key.indexOf('.mov') > 0"
                  preload="none"
                  poster="http://statica.xuantu.pro/static/upload/20260121_upload_3961633838326165.jpeg"
                  :src="rawImage(record.base_image_key)"
                  controls
                  style="max-width: 200px; max-height: 356px;"
                />
                <a-image 
                  v-else
                  placehoder=false
                  :preview='{ src: rawImage(record.base_image_key)}'
                  :src="thumbnail(record.base_image_key)"
                />
                <a-tag color="blue" >原图</a-tag>
              </div>

              <div v-if="record.mask_image_key" class="thumbnail-item">
                <a-image 
                  placehoder=false
                  :preview="{src: rawImage(record.mask_image_key)}"
                  :src="thumbnail(record.mask_image_key)"
                />
                <a-tag color="black" >MASK</a-tag>
              </div>
              <div v-else class="thumbnail-item thumbnail-item-block" >
                NO MASK
              </div>
              <div v-if="record.refer_image_key" class="thumbnail-item">
                 <video 
                  v-if="record.refer_image_key.indexOf('.mp4') > 0 || record.refer_image_key.indexOf('.mov') > 0"
                  preload="none"
                  poster="http://statica.xuantu.pro/static/upload/20260121_upload_3961633838326165.jpeg"
                  :src="rawImage(record.refer_image_key)"
                  controls
                  style="max-width: 200px; max-height: 356px;"
                />
                <a-image 
                  v-else
                  placehoder=false
                  :preview='{ src: rawImage(record.refer_image_key)}'
                  :src="thumbnail(record.refer_image_key)"
                />
                <a-tag color="orange" >参考图</a-tag>
              </div> 
              <div v-else class="thumbnail-item thumbnail-item-block" >
                NO REFERENCE
              </div>
              <div v-if="record.work_image_key" class="thumbnail-item">
                <video 
                  v-if="record.work_image_key.indexOf('.mp4') > 0"
                  preload="none"
                  poster="http://statica.xuantu.pro/static/upload/20260121_upload_3961633838326165.jpeg"
                  :src="rawImage(record.work_image_key)"
                  controls
                  style="max-width: 200px; max-height: 356px;"
                />
                <a-image 
                  v-else
                  placehoder=false
                  :preview='{ src: rawImage(record.work_image_key)}'
                  :src="thumbnail(record.work_image_key)"
                />
                <a-tag color="green" >结果图</a-tag>
              </div>
               <div v-else class="thumbnail-item thumbnail-item-block" >
                NO RESULT
              </div>
            </a-image-preview-group>

          
        </div>
      </template>
      <template #task_status="{ record }">
        <div  v-if="record.task_status == 0">
          <a-progress type="circle" :percent="0" size="small" />
        </div>
        <div  v-else-if="record.task_status == 1">
          <a-progress type="circle" :percent="record.progress" size="small" />
        </div>
        <div v-else-if="record.task_status == 3" class="task-status-error">
          <a-tooltip :title="record.response">
            ❌ 失败 ({{ record.errmsg }})
          </a-tooltip>
        </div>
        <div v-else-if="record.task_status == 4" class="task-status-stopped">
          ⛔️ 终止
        </div>
        <div v-else>
          ✅
        </div>
      </template>
       <template #expandedRowRender="{record}">
        <div style="background: #EFEFEF;padding:10px;">
          <div v-for="(value, key) of record" :key="key">
            <a-row >
              <a-col :span="3" >{{ key }}:</a-col>
              <a-col :span="21" style="margin-top:4px;" >
                <div v-if="key == 'extra_params' || key == 'works'">
                  <pre>{{ value }}</pre>
                </div>
                <div v-else-if="typeof value == 'number' ">
                  <a-tag>{{ value }}</a-tag>
                </div>
                 <div v-else-if="value === '' ">
                
                   <a-tag>&lt;empty&gt;</a-tag>
                </div>
                <div v-else>{{ value }}</div>
              </a-col>
            </a-row>
          </div>
        </div>
      </template>
      <template #cost_duration="{ record }">
         {{ record.cost_duration }}s
      </template>
      <template #action="{ record }" >
        <div class="task-actions">
          <div class="task-actions-list">
             <a-button size="small" v-if="batch_id" @click="handlePreviewCase(record)">查看用例({{ record.case_id }})</a-button>
            <a-button size="small" @click="handlePreviewPayload(record)">请求参数</a-button>
            <TestcaseDiff 
              size="small"
              btn_text="对比结果"
              v-if="record.task_status ==2 " 
              :origin_image="''" 
              :case_id="record.case_id ? record.case_id : ''" 
              :target_image="record.work_image_key" />
             <TestcaseDiff 
              size="small"
              btn_text="对比原图"
              v-if="record.task_status ==2 " 
              :origin_image="record.base_image_key" 
              :case_id="record.case_id ? record.case_id : ''" 
              :target_image="record.work_image_key" />
             <TestcaseDiff
              size="small"
              btn_text="对比原始任务"
              v-if="record.task_status ==2"
              :origin_image="record.base_image_key"
              :case_id="record.case_id ? record.case_id : ''"
              :case-target-image="true"
              :target_image="''" />
          
          </div>
        </div>
      </template>
      <template #operator_id="{ record }">
        <Username :user_id="record.operator_id" />
      </template>
    </a-table>
    <!-- <div>
      <a-flex justify="flex-start" wrap="wrap" gap="small" style="margin: 10px;">
       <a-image-preview-group  >
        <div v-for="(record, index) in dataSource" :key="index" class="thumbnail-item">
          <div  v-if="record.task_status == 2">
            <a-image 
              v-if="record.work_image_key"
              placehoder=false
              :preview='{ src: rawImage(record.work_image_key)}'
              :src="thumbnail(record.work_image_key)"
            />
          </div>
          <div  v-if="record.task_status == 0">
            <a-progress type="circle" :percent="0" size="small" />
            排队中
          </div>
          <div  v-else-if="record.task_status == 1">
            <a-progress type="circle" :percent="record.progress" size="small" />
          </div>
          <div  v-else-if="record.task_status == 4" style="margin: 10px;">
           ⛔️ 已终止
          </div>
          <p style="margin:10px;" v-if="!batch_id && record.remark" >{{ record.remark }}</p>

          <div class="case-img-fail" v-if="record.task_status == 3">
            Error: <div style="word-wrap: break-word; padding: 8px;">{{ record.errmsg }}</div>
          </div>
          <a-flex class="tags-wrap" justify="flex-start" wrap="wrap" gap="small" >
            
            <a-tag  color="gray" >case_task_id: {{ record.id }}</a-tag>
            <a-tag  color="gray" >case_id: {{ record.case_id }}</a-tag>
            <a-tag v-if="record.template_id > 0" color="gray" >teamplte: {{ record.template_id }}</a-tag>
            <a-tag  color="yellow">cost: {{ record.cost_duration }}s</a-tag>
            <a-tag  color="blue" >by {{ Operators[record.operator_id] }}</a-tag>
            <a-tag color="blue" >create: {{ record.created_at }}</a-tag>

            <a-button  v-if="batch_id" size="small" @click="handlePreviewCase(record)">查看用例</a-button>
            <a-button  size="small" @click="handlePreviewPayload(record)">请求参数</a-button>
            <TestcaseDiff v-if="record.task_status ==2 " :origin_image="currentCase.work_image_key" :case_id="record.case_id ? record.case_id : ''" :target_image="record.work_image_key" />
          
          </a-flex>
        </div>
      </a-image-preview-group>
      </a-flex>
      <a-pagination
        v-model:current="pagination.current"
        v-model:pageSize="pagination.pageSize"
        show-size-changer
        show-quick-jumper
        @change="(current, pageSize) => handleTableChange({current, pageSize})"
        :total="pagination.total"
      />
    </div>
     -->
  
  </a-card>
  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent,  h,onMounted} from 'vue'
import { Modal, message } from 'ant-design-vue';

import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import { useStore } from 'vuex'
import {useRoute} from 'vue-router'
import {Operators} from '@/utils/macro'
import { StyleFlowNames, ToolIDOptions} from '@/utils/macro'
import {thumbnail , rawImage} from '@/utils/image'

import TestcaseRun from '@/components/TestcaseRun.vue'
import TestcaseDiff from '@/components/TestcaseDiff.vue'
import Username from '@/components/Username.vue'
// 0排队中 1创作中 2创作完成 3创作失败
const TaskStatus = {
  0: "🚗 排队中..",
  1: "🚀 创作中.. ",
  2: "✅ 创作完成 ",
  3: "❌ 创作失败 ",
}
export default defineComponent({
  components: {
    // SearchOutlined,
    TestcaseRun,
    TestcaseDiff,
    Username,
  },
  data(){
    return {
      loading: false,
      dataSource: [],
      pageNo: 0,
      StyleFlowNames,
      Operators,
      ToolIDOptions,
      preset_ids:"",
      batch_id: "",
      route: useRoute(),
      currentBatch:{},
      currentCase:{},
      case_id: 0,
      showMoreCaseParams: "",
      showFirst: false,
      statusOptions: [{
          label: "所有", value: '',
        },
        {
          label: "排队中", value: 0
        }, {
          label: "执行中", value: 1
        }, {
          label: "执行成功", value: 2
        }, {
          label: "执行失败", value: 3
        }, {
          label: "执行退出", value: 4
        }
      ],
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-quick-jumper': true,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '性能问题，总条数不再展示',
      reviewVisible: false,
      diffcase: {},
      formSearch: {
        template_id: '',
        tool_id: '',
        style_id: '',
        sub_type: '',
        status: '',
        user_id: '',
        task_id: '',
        queue_name: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    this.reload()
  },
  computed:{
  },
  methods: {
    reload(){
      const route = this.route
      if (route.query['case_id']) {
        this.case_id = route.query['case_id']
        this.GetCase()
      } else if (route.query['batch_id']) {
        this.batch_id = route.query['batch_id']
        this.GetBatch()
      } else {
        return
      }
    
      this.handleTableChange()
    },
    GoPrev(){
      this.$router.back()
    },
    async CaseExecuted(){
      // 睡眠 1 s
      await new Promise(resolve => setTimeout(resolve, 1000))
      this.handleTableChange()
    },
    handlePreviewPayload(record){
      Modal.info({
        title: '请求参数',
        content: h('pre', {
          style:{
            background: "#EEE",
            padding: "8px",
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
          }
        }, record.payload),
      })
    },
    handleStopBatch(){
      Modal.confirm({
        title: '确认终止执行吗？',
        okText: '确认',
        okType: 'danger',
        onOk: async () => {
          const rsp = await request.put(`/api/testcase/batches/${this.batch_id}`, {
            status: 4,
          })
          if (rsp.code == 0) {
            message.success('终止执行成功')
            this.GetBatch()
          } else {
            message.error(rsp.msg)
          }
        },
      })
    },
     async handleRerun(record){
      record.loading = true
      const rsp = await request.post(`/api/testcase/batches/${record.id}/retry`, {  })
      record.loading = false
      if(rsp.code == 0) {
        this.$router.push({path: '/home/testcase/tasks', query: {batch_id: rsp.data.batch_id}})
        setTimeout(() => {
          location.reload()
        }, 500)
      } else {
        message.error(rsp.message)
      }

    },
    handlePreviewCase(record){
      const url = this.$router.resolve({
        path: '/home/testcase/tasks',
        query: {
          case_id: record.case_id,
        }
      }).href
      window.open(url, '_blank')
    },
    async GetCase(){
      this.loading = true
      const rsp = await request.get(`/api/testcase/cases/${this.case_id}`)
      this.loading = false
      if (rsp.code == 0) {
        this.currentCase = rsp.data.item
      } else {
        message.error(rsp.message)
      }
    },
    async GetBatch(){
      this.loading = true
      const rsp = await request.get(`/api/testcase/batches/${this.batch_id}`)
      this.loading = false
      if (rsp.code == 0) {
        this.currentBatch = rsp.data.item
      } else {
        message.error(rsp.msg)
      }
    },
    async handleDiff(record){
      const targetCaseRes = await request.get(`/api/testcase/cases/${record.case_id}`)
      let targetCase = {}
      if (targetCaseRes.code == 0) {
        targetCase = targetCaseRes.data.item
      } else {
        message.error(targetCaseRes.msg)
      }
    },
    async handelRun(record){
      this.loading = true
      request.post(`/api/testcase/cases/${record.id}/run`, {
        case_id: record.id,
      }, null).then((rsp) => {
        if (rsp.code == 0) {
          message.success('运行成功，请等待执行完毕')
        } else {
          message.error(rsp.msg)
        }
      }).catch((err) => {
        message.error(err.message)
      }).finally(() => {
        this.loading = false
      })
    },
    thumbnail,
    rawImage,
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      let limit = pagi.pageSize
      let orderBy = "id desc"
      let offset =  (pagi.current - 1) * pagi.pageSize
      const rsp = await request.get(`/api/testcase/cases/${this.case_id}/tasks`, {
        offset: offset,
        limit: limit,
        order_by: orderBy,
        batch_id: this.batch_id,
        ...this.formSearch,
        // after_cursor: afterCursor,
        // before_cursor: beforeCursor,
      })
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      
      for(let i in this.dataSource) {
        let item = this.dataSource[i]
        if (this.dataSource[i].extra_params != "") {
          // this.dataSource[i].extra_params = JSON.parse(item.extra_params)
          item = this.dataSource[i]
          this.dataSource[i].created_at = new Date(this.dataSource[i].created_at).toLocaleString()
          this.dataSource[i].updated_at = new Date(this.dataSource[i].updated_at).toLocaleString()
        } 
        // if (this.dataSource[i].payload) {
        //   const payload = JSON.parse(item.payload)
        //   this.dataSource[i].base_image_key = payload.init_image
        //   this.dataSource[i].mask_image_key = payload.mask_image
        //   this.dataSource[i].prompt = payload.text_prompt
        //   this.dataSource[i].refer_image_key = payload.userdefined
        // }
      }
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`

      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
    
  },
  setup(props, context) {
   
    return {
      TaskStatus,
      uploadInput: null,
      columns: [
      {
          title: 'Task ID',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '图例',
          dataIndex: 'base_image_key',
          key: 'base_image_key',
          slots: { customRender: 'image_gallary' },
          width: 820,
        },
         {
          title: 'Prompt',
          dataIndex: 'prompt',
          key: 'prompt',
          slots: { customRender: 'prompt' },
        },
        //  {
        //   title: 'TaskID',
        //   dataIndex: 'task_id',
        //   slots: { customRender: 'task_id' },
        // },
        {
          title: '状态',
          dataIndex: 'task_status',
          key: 'task_status',
          slots: { customRender: 'task_status' },
          width: 72,
        },
      
        {
          title: '耗时',
          dataIndex: 'cost_duration',
          key: 'cost_duration',
          slots: { customRender: 'cost_duration' },
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          // slots: { customRender: 'created_at' },
        },
        {
          title: '操作人',
          dataIndex: 'operator',
          key: 'operator',
          slots: { customRender: 'operator_id' },
        },
         {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
          width: 190,
        },
        // {
        //   title: '任务开始时间',
        //   dataIndex: 'task_start_at',
        //   key: 'task_start_at',
        //   slots: { customRender: 'task_start_at' },
        // },
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.thumbnail-wraps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.prompt-container {
  cursor: pointer;
  max-height: 350px;
  max-width: 100px;
  overflow-y: scroll;
}
.prompt-container:hover {
  color: red;
}
.thumbnail-item {
  display: inline-block;
  /* flex-direction: row; */
  width: 200px;
  background: #EFEFEF;
  margin: 2px;
  padding: 4px;
  text-align: center;
}
.case-image-item {
  width: 200px;
}
.case-img-fail {
  border: 1px solid red;
  color: red;
  display: block;
}
.tags-wrap {
  padding:8px;
}
.task-status-error,
.task-status-stopped {
  white-space: nowrap;
}
.task-actions {
  width: 180px;
}
.task-actions-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
</style>
